import { render, staticRenderFns } from "./jf-vorbereitungsprogramm.vue?vue&type=template&id=3b3ee73f&scoped=true&lang=pug&"
import script from "./jf-vorbereitungsprogramm.vue?vue&type=script&lang=js&"
export * from "./jf-vorbereitungsprogramm.vue?vue&type=script&lang=js&"
import style0 from "./jf-vorbereitungsprogramm.vue?vue&type=style&index=0&id=3b3ee73f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ee73f",
  null
  
)

export default component.exports